import { Injectable } from '@angular/core';
import { UseService } from '@df/util/service/use.service';

export const DRAGGING_USE_SERVICE_KEY = 'dragging';
@Injectable({
    providedIn: 'root'
})
export class DraggingService {
    constructor(private useService: UseService) {}

    lock(source: any) {
        this.useService.lock(DRAGGING_USE_SERVICE_KEY, source);
    }

    release(source: any) {
        this.useService.unlock(DRAGGING_USE_SERVICE_KEY, source);
    }

    get isLocked(): boolean {
        return this.useService.isLocked(DRAGGING_USE_SERVICE_KEY);
    }
}
